export enum MediaAspectRatio {
	'4:3' = '4_3_crop',
	Original = 'original_crop',
}
